interface IRoleData {
  id: string;
  name: string;
  composite: boolean;
  clientRole: boolean;
  containerId: string;
}

interface ILanguageData {
  id: string;
  name: string;
}

interface IReportData {
  id: string;
  name: string;
}

export interface IUserViewData {
  id: string;
  username: string;
  firstName: string;
  lastName:string;
  displayName: string;
  email: string;
  role: IRoleData;
  languagePreferred?: ILanguageData;
  description?: string;
  reportTemplate?: IReportData;
  isEnabled?: boolean;
}

export interface IUserViewLabel {
  firstNameLabel: string;
  lastNameLabel: string;
  roleLabel: string;
  emailLabel: string;
  userNameLabel: string;
  languagePreferredLabel?: string;
  descriptionLabel?: string;
  reportTemplateLabel?: string;
}

export default class UserViewData implements IUserViewData, IUserViewLabel {
  id: string;
  username: string;
  firstName: string;
  lastName:string;
  displayName: string;
  email: string;
  role: IRoleData;
  languagePreferred?: ILanguageData;
  description?: string;
  reportTemplate?: IReportData;
  isEnabled?: boolean;

  firstNameLabel: string;
  lastNameLabel: string;
  roleLabel: string;
  emailLabel: string;
  userNameLabel: string;
  languagePreferredLabel?: string;
  descriptionLabel?: string;
  reportTemplateLabel?: string;

  constructor(
    id: string,
    firstName: string,
    lastName: string,
    displayName: string,
    email: string,
    username: string,
    role: IRoleData,
    languagePreferred: ILanguageData,
    description: string,
    reportTemplate:IReportData,
    isEnabled: boolean,
  ) {
    this.id = id;
    this.firstName = firstName;
    this.lastName = lastName;
    this.displayName = displayName;
    this.role = role;
    this.email = email;
    this.username = username;
    this.languagePreferred = languagePreferred;
    this.description = description;
    this.reportTemplate = reportTemplate;
    this.isEnabled= true;

    this.firstNameLabel = "First Name";
    this.lastNameLabel = "Last Name";
    this.roleLabel = "Role";
    this.emailLabel = "Email";
    this.userNameLabel = "User Name";
    this.languagePreferredLabel = "Language Preferred";
    this.descriptionLabel = "Description";
    this.reportTemplateLabel = "Report Template";
    }
}

const defaultUserData = new UserViewData("", "", "", "", "", "", {id:"", name:"", composite:false, clientRole:false, containerId:""}, {id:"", name:""},"",{id:"", name:""},false);
export { defaultUserData };
